import { getFeatures, FeatureType } from "common/features";
import { ds } from "./dataService";

export { FeatureType };

export async function getUserOrgPermissions(orgId) {
    await ds.teams.loadModels();
    const role = ds.teams.defaultTeamForOrg(orgId).getUserRole();
    const permissions = getFeatures(role);
    return permissions;
}

export async function getUserPlanPermissions() {
    await ds.userPlans.loadModels();
    const permissions = getFeatures(ds.userPlans.getPersonalPlan());
    return permissions;
}
